import React from 'react';
import styles from './styles.module.scss';

import { ReactComponent as FavoriteIcon } from '../../../assets/icons/icon-favorite.svg';

const Share = ({ content, spanish }) => (
  <div className={styles.favorite}>
    <FavoriteIcon />
    <div>{spanish ? content?.WishlistSpanish : content?.WishlistEnglish}</div>
  </div>
);

export default Share;
